var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.12 120.92C126.86 123.93 122.58 124.54 119.57 122.28L92.29 101.82C90.58 100.53 89.5599 98.5101 89.5599 96.3601V48.63C89.5599 44.86 92.6099 41.8101 96.3799 41.8101C100.15 41.8101 103.2 44.86 103.2 48.63V92.9501L127.75 111.36C129.2 112.44 130.15 114.06 130.41 115.85C130.67 117.64 130.2 119.46 129.11 120.9L129.12 120.92ZM96.39 0.910034C71.07 0.910034 46.7899 10.9701 28.8799 28.8701C10.9799 46.7801 0.919922 71.06 0.919922 96.38C0.919922 121.7 10.9799 145.98 28.8799 163.89C46.7899 181.79 71.07 191.85 96.39 191.85C121.71 191.85 145.99 181.79 163.9 163.89C181.8 145.98 191.86 121.7 191.86 96.38C191.83 71.07 181.77 46.81 163.87 28.91C145.97 11.01 121.7 0.950044 96.4 0.920044L96.39 0.910034Z",
    fill: "#0E9CFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.af57abf0b1ef3843929e75912cd15f3f.svg";
export { ForwardRef as ReactComponent };